<template>
  <content-container :table-row-count="tableData.length">
    <div v-if="(from=='company'&&source=='company')||(from=='agent'&&source=='agent')" class="mb-[12px] flex justify-end">
      <el-button type="primary" @click="goToChangeBank">
        账户绑卡
      </el-button>
    </div>
    <el-table v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :max-height="maxHeight" :data="tableData">
      <el-table-column align="center" prop="bankCardNo" label="银行账户" show-overflow-tooltip :min-width="180" />
      <el-table-column align="center" prop="bankAccountName" label="银行账户名" show-overflow-tooltip :min-width="260" />
      <el-table-column align="center" prop="status" label="绑定状态" :min-width="130">
        <template #default="scope">
          <custom-tag :label="yibaoBindStatus[scope.row.status]" :type="yibaoBindStatusStyle[scope.row.status]" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="bankCode" label="企业开户银行" :min-width="160">
        <template #default="scope">
          {{ getBankName(scope.row.bankCode) }}
        </template>
      </el-table-column>

      <el-table-column align="center" prop="bankCityCode" label="开户城市" :min-width="120">
        <template #default="scope">
          {{ getCityName(scope.row.bankCityCode) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="bankBranch" label="开户支行" show-overflow-tooltip :min-width="260" />
      <el-table-column align="center" prop="cnapsCode" label="大额行号" :min-width="160" />

      <el-table-column
        v-if="(from=='company'&&source=='company')||(from=='agent'&&source=='agent')"
        align="center"
        prop="actions"
        fixed="right"
        label="操作"
      >
        <template #default="scope">
          <el-button
            type="primary"
            link
            :disabled="scope.row.isDefault"
            @click="goToDeleteBank(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部分页 -->
    <template #footer>
      <el-pagination
        v-model:current-page="params.page"
        v-model:page-size="params.size"
        :class="{ 'fix-fixed-footer': fixedFooter }"
        :page-sizes="[defaultPageSize, 25, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="onSizeChange"
        @current-change="onCurrentPageChange"
      />
    </template>

    <password-verification-dialog
      :visible="showDeleteBinkDialog"
      :phone="phone||''"
      :title="'删除确认'"
      @close="showDeleteBinkDialog = false"
      @confirm="onDeleteBank"
    />
  </content-container>
</template>

<script setup lang="ts">
import { CustomTag } from '@vue3/components';
import { areaList } from '@core/tools';
import { computed, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { IAgentMergeInfo, ICompanyMergeInfo } from '../../../../types/common';
import { IMasterBank } from '../../../../types/yibao';
import { IYibaoAccountBank, yibaoBindStatus, yibaoBindStatusStyle } from '../../../../types/yibao-manage';
import { ContentContainer, useCardTableHeightFix, queryYibaoBankAccountList, CancelBankAccount, queryComapnyDetail, useUserStore, PasswordVerificationDialog, queryAgentDetail } from '../../../..';

defineOptions({ name: 'BindBank' });

const props = defineProps({
  basicBankList: {
    type: Array<IMasterBank>,
    default() {
      return [] as IMasterBank[];
    },
  },
  from: {
    type: String,
    default: 'saas',
  },
});

const router = useRouter();
const route = useRoute();
const yibaoId = computed(() => Number(route.query.yibaoId));
const source = computed(() => route.query.from || 'company');
const loading = ref(false);
const tableData = ref([]);
const defaultPageSize = 12;
const total = ref(0);
const params = reactive({
  id: yibaoId.value,
  page: 1,
  size: defaultPageSize,
});
const deleteBankRowInfo = ref<IYibaoAccountBank>({} as IYibaoAccountBank);

const { state: userState } = useUserStore();
const companyInfo = ref({} as ICompanyMergeInfo);
const agentInfo = ref({} as IAgentMergeInfo);
const companyId = computed(() => userState.identity?.companyId);
const agentId = computed(() => userState.identity?.agentDTO?.id);
const phone = computed(() => source.value == 'company' ? companyInfo.value?.companyPay?.payPhone : agentInfo.value?.agentPay?.payPhone);

const { maxHeight, fixedFooter } = useCardTableHeightFix(total);

const showDeleteBinkDialog = ref(false);

function getBankName(code: string) {
  const item = props.basicBankList.find((v) => v.bankCode === code);

  return item ? item.bankName : '';
}
function getCityName(code: string) {
  for (var i = 0; i < areaList.length; ++i) {
    if (areaList[i].value === code) return areaList[i].label;
    if (!areaList[i].children) continue;
    for (var j = 0; j < areaList[i].children.length; ++j) {
      if (areaList[i].children[j].value === code) return areaList[i].children[j].label;
    }
  }
}

async function fetchData() {
  loading.value = true;

  try {
    const { data, total: all } = await queryYibaoBankAccountList({ ...params }, source.value == 'company');

    tableData.value = data;
    total.value = all;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function onSizeChange(size: number) {
  params.size = size;
  params.page = 1;
  fetchData();
}

function onCurrentPageChange(page: number) {
  params.page = page;
  fetchData();
}
function goToDeleteBank(row: IYibaoAccountBank) {
  deleteBankRowInfo.value = row;
  showDeleteBinkDialog.value = true;
}

function goToChangeBank() {
  router.push({
    path: '/air-splitting/yibao/change-bind-bank',
    state: {
      id: yibaoId.value,
      phoneNo: phone.value || '', 
      from: source.value,
    }, 
  });
}

async function onDeleteBank(val) {
  try {
    await CancelBankAccount({
      id: yibaoId.value, 
      bankCardNo: deleteBankRowInfo.value.bankCardNo,
      payPassword: val.payPassword,
      verifyCode: val.verifyCode,
    }, source.value == 'company');
    ElMessage.success('删除成功');
    deleteBankRowInfo.value = {} as IYibaoAccountBank;
    showDeleteBinkDialog.value = false;

    fetchData();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function fetchCompanyDetail() {
  try {
    companyInfo.value = await queryComapnyDetail(companyId.value);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function fetchAgentDetail() {
  try {
    agentInfo.value = await queryAgentDetail(agentId.value);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function init() {
  await fetchData();
  if (props.from == 'company' && source.value == 'company') {
    await fetchCompanyDetail();
  } else if (props.from == 'agent' && source.value == 'agent') {
    await fetchAgentDetail();
  }
}

init();
</script>

<style lang="scss" scoped>
:deep(.number-range-input.sxf) {
  & > span {
    position: relative;
    left: -15px;
  }
}

</style>
